import { omit } from 'lodash';
import { IdentityDocumentType } from '../../domain/types';
import { geoFormModelToGeo, geoToGeoFormModel } from '../../geo/components/form-geo-field/mappers';
import { AIAnnotationContactData, Contact } from '../../providers/api/dtos';
import { formatInputDate } from '../../utils/form';
import { ContactFormModel } from '../components/contact-form/ContactForm';

export const normalizeAiContactDataToContact = (aiContact: AIAnnotationContactData): Contact => omit({ ...aiContact, birthplace: aiContact.birthPlace, birthday: aiContact.birthDay }, ['birthDay', 'birthPlace']);

export const contactToContactFormModel = (contact: Contact): ContactFormModel => ({
  name: contact.name,
  phoneNumber: contact.phoneNumber,
  email: contact.email,
  fiscalCode: contact.fiscalCode,
  address: geoToGeoFormModel(contact.residence),
  notes: contact.notes,
  identityDocument: contact.identityDocument ? {
    type: contact.identityDocument.type,
    number: contact.identityDocument.number,
    issuedBy: contact.identityDocument.issuedBy,
    issuedAt: contact.identityDocument.issuedAt
      ? formatInputDate(new Date(contact.identityDocument.issuedAt))
      : undefined,
  } : undefined,
  birthDate: contact.birthday
    ? formatInputDate(new Date(contact.birthday))
    : undefined,
  birthPlace: contact.birthplace,
  citizenship: contact.citizenship,
});

export const contactFormModelToContact = (model: ContactFormModel): Partial<Contact> => ({
  name: model.name?.trim() || undefined,
  phoneNumber: model.phoneNumber?.trim() || undefined,
  email: model.email?.trim() || undefined,
  fiscalCode: model.fiscalCode?.trim() || undefined,
  residence: model.address ? geoFormModelToGeo(model.address) : undefined,
  notes: model.notes?.trim() || undefined,
  identityDocument: model.identityDocument ? {
    type: model.identityDocument.type?.trim() as IdentityDocumentType || undefined,
    number: model.identityDocument.number?.trim() || undefined,
    issuedBy: model.identityDocument.issuedBy?.trim() || undefined,
    issuedAt: model.identityDocument.issuedAt?.trim() ? new Date(model.identityDocument.issuedAt?.trim()).toISOString() : undefined,
  } : undefined,
  birthday: model.birthDate?.trim() ? new Date(model.birthDate?.trim()).toISOString() : undefined,
  birthplace: model.birthPlace?.trim() || undefined,
  citizenship: model.citizenship?.trim() || undefined,
});
